import * as RadixProgress from '@radix-ui/react-progress';

import styles from './styles/Progress.module.scss';
import { toPercentage } from './util/toPercentage';

const Progress = ({ disabled = false, ...progressProps }: { disabled?: boolean } & RadixProgress.ProgressProps) => {
  if (!progressProps['aria-label'] && !progressProps['aria-labelledby'] && !progressProps['title']) {
    console.warn('Progress component must provide and `aria-label`, `aria-labelledby` or `title` attribute ');
  }
  const { max, value } = progressProps;

  if (typeof value !== 'number') return null;

  const percentage = toPercentage(value, max);

  return (
    <div className={styles.progressWrapper} data-cxy-name="progress" data-disabled={disabled}>
      <p className={styles.value}>{percentage}%</p>
      <RadixProgress.Root className={styles.progressRoot} {...progressProps}>
        <RadixProgress.Indicator
          className={styles.progressIndicator}
          style={{ transform: `translateX(-${100 - percentage}%)` }}
        />
      </RadixProgress.Root>
    </div>
  );
};

export { Progress };
